export default {
  zh: {
    affiliate: '推广联盟',
    withdrawDetails: '提现明细',
    noRecords: '无提现记录',
    CNY: '￥',
    USD: '$',
    time: '申请时间',
    amount: '提现金额',
    account: '提现账户',
    status: '提现状态',
    submitted: '申请已提交',
    pending: '处理中',
    paid: '已转账',
    ':': '：'
  },
  en: {
    affiliate: 'Affiliate',
    withdrawDetails: 'Withdraw Details',
    noRecords: 'No records',
    CNY: '￥',
    USD: '$',
    time: 'Application Date',
    amount: 'Withdraw Amount',
    account: 'Account Name',
    status: 'Status',
    submitted: 'Your application has been submitted',
    pending: 'Pending',
    paid: 'Paid',
    ':': ':'
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawDetails/lang.js